module.exports = __webpack_public_path__ + "static/img/avatar_r_7.fc7c6637.png";